var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDocuments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "M207 65a7 7 0 1 1 0 14h-40a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-10.174c-4.874 0-8.826 3.134-8.826 7q0 3.866 6 7a7 7 0 1 1 0 14H93a7 7 0 1 1 0-14H54a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H69a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm0 28a7 7 0 1 1 0 14 7 7 0 0 1 0-14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m153.672 64 9.302 67.843.835 6.806a4 4 0 0 1-3.482 4.458l-58.561 7.19a4 4 0 0 1-4.457-3.483l-9.016-73.427a2 2 0 0 1 1.741-2.23q.01 0 .021-.002l4.859-.545m3.928-.44 4.587-.515z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M155.158 63.796a1.5 1.5 0 0 0-2.972.408zm7.816 68.047 1.489-.183-.003-.021zm.835 6.806 1.489-.183zm-3.482 4.458.183 1.488zm-58.561 7.19.183 1.489zm-4.457-3.483 1.489-.183zm-9.016-73.427 1.489-.183zm1.762-2.232.167 1.491zm5.026.946a1.5 1.5 0 0 0-.335-2.981zm3.594-3.422a1.5 1.5 0 0 0 .334 2.981zm4.921 2.467a1.5 1.5 0 1 0-.334-2.981zm48.59-6.942 9.302 67.842 2.972-.407-9.302-67.843zm9.299 67.821.836 6.807 2.977-.366-.835-6.806zm.836 6.807a2.5 2.5 0 0 1-2.177 2.786l.366 2.977a5.5 5.5 0 0 0 4.788-6.129zm-2.177 2.786-58.56 7.19.365 2.978 58.561-7.191zm-58.56 7.19a2.5 2.5 0 0 1-2.786-2.177l-2.978.366a5.5 5.5 0 0 0 6.129 4.789zm-2.786-2.177-9.016-73.427-2.978.366 9.016 73.427zm-9.016-73.427a.5.5 0 0 1 .435-.557l-.365-2.978a3.5 3.5 0 0 0-3.048 3.9zm.435-.557h.005l-.334-2.982-.036.004zm.005 0 4.859-.546-.335-2.981-4.858.545zm8.787-.987 4.587-.514-.334-2.981-4.587.514z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "m151.14 68.27 8.42 61.483.757 6.168c.244 1.987-1.15 3.793-3.114 4.035l-52.442 6.439c-1.963.241-3.753-1.175-3.997-3.162l-8.15-66.376a2 2 0 0 1 1.742-2.23l6.487-.796",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#374151",
  strokeWidth: 3,
  d: "M108.172 54a2.5 2.5 0 0 1 2.5-2.5h45.557c.662 0 1.298.263 1.767.732l13.443 13.435c.469.468.733 1.105.733 1.768V130a2.5 2.5 0 0 1-2.5 2.5h-59a2.5 2.5 0 0 1-2.5-2.5z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#374151",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M156.672 52.403V64a3 3 0 0 0 3 3h7.933"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA3AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M118 118h26m-26-51h26zm0 12h43zm0 13h43zm0 13h43z"
})));
export default SvgDocuments;